import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'gatsby'
import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlobe } from '@fortawesome/free-solid-svg-icons'

config.autoAddCss = false

const Footer = ({ pathname, linksTo, noEnglish }) => {
  return (
    <footer>
      <Container fluid>
        <Row>
          <Col>
            <div className="container col-11 footer">
              <div className="row mb-5 pt-5">
                <div className="col-12 col-md-3 mt-4">
                  <strong>Kontaktieren Sie uns</strong>
                  <br />
                  <strong>E</strong> hallo@ganztags.net
                </div>
                <div className="col-12 col-md-5 mt-4">
                  <strong>Über ganztags.</strong>
                  <br />
                  <Link to="/team/">Über uns</Link>&nbsp;| <Link to="/leistungen/">Leistungen</Link>&nbsp;|{' '}
                  <Link to="/kunden/">Kunden</Link>&nbsp;| <Link to="/jobs/">Jobs</Link>&nbsp;|{' '}
                  <Link to="/kontakt/">Kontakt</Link>&nbsp;| <Link to="/infothek/">Infothek</Link>{' '}
                </div>

                {!noEnglish && (
                  <div className="col-12 col-md-4 text-md-right mt-4">
                    <a href={linksTo ? `/en/${linksTo}` : `/en${pathname}`}>
                      <FontAwesomeIcon icon={faGlobe} /> English version
                    </a>
                  </div>
                )}
              </div>
              <Row className=" pt-3 pb-5">
                <Col xs={12} sm={3}>
                  <h3>
                    <strong>ganztags.</strong>
                  </h3>
                </Col>
                <Col>
                  <a href="/impressum/" id="imp">
                    Impressum & Datenschutz
                  </a>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer
